import { ModalsKey } from '@/enums/modalsKey';
import { AuthService } from '@/services/AuthService';
import { ModalLayout } from '@starsoft/common/components';
import useTranslation from 'next-translate/useTranslation';
import CoinConversionModalContent from './Content';
import { ModalWithVersion } from '../core/Modal/WithVersion';

export default function CoinConversionModal() {
  const { t } = useTranslation('common');

  return (
    <ModalWithVersion
      smallMobilePadding
      fitContent
      title={t('information')}
      modal={ModalsKey.CoinConversion}
      condition={AuthService.isAuthorized()}
    >
      <CoinConversionModalContent />
    </ModalWithVersion>
  );
}
